import { module } from 'angular'

export default module('_facturacion.configuracion', ['facturacion.configuracion'])



// WEBPACK FOOTER //
// ./src/facturacion/configuracion/module.js